export const GET_BRANDS_REQUEST   = "GET_BRANDS_REQUEST";
export const GET_BRANDS_SUCCESS   = "GET_BRANDS_SUCCESS";
export const GET_BRAND_REQUEST    = "GET_BRAND_REQUEST";
export const GET_BRAND_SUCCESS    = "GET_BRAND_SUCCESS";
export const DELETE_BRAND_REQUEST = "DELETE_BRAND_REQUEST";
export const DELETE_BRAND_SUCCESS = "DELETE_BRAND_SUCCESS";
export const GET_REQUEST_ERROR    = "GET_REQUEST_ERROR";
export const GET_REQUEST_SUCCESS  = "GET_REQUEST_SUCCESS";